{
  "data_sets": {
    "summary": {
      "dataset_selection": "{{count}} Datenset ausgewählt",
      "dataset_selection_plural": "{{count}} Datensets ausgewählt",
      "size_info": "Total: {{total}}, Total während Import: {{totalImport}}, Verbleibend: {{accessible}}, Verfügbar: {{available}}"
    },
    "hints": {
      "readonly_meaning": "Datenset schreibgeschüzt oder editierbar importieren"
    },
    "long_import_hint": "Das Importieren kann je nach Datenset eine lange Zeit in Anspruch nehmen",
    "categories_list_title": "Kategorien",
    "categories_grid_title": "Wählen Sie Datensets zum Importieren aus",
    "no_datasets_in_category": "Es gibt zu dieser Kategorie keine Datensets",
    "database": "Datenbank",
    "search": "Suche",
    "dataset_name": "Datenset Name",
    "disable_reasons": {
      "dataset_already_queued": "Dieses Datenset ist bereits in der Import-Warteschlange.",
      "dataset_already_importing": "Dieses Datenset wird momentan importiert.",
      "dataset_already_imported": "Dieses Datenset wurde bereits importiert - bitte überprüfen Sie den Status im Datenset Tab.",
      "schema_conflict": "Es existiert bereits ein anderes Schema mit dem Namen {{schemaName}} in dieser Datenbank.",
      "insufficient_space": "Es gibt nicht mehr aussreichend Speicherplatz, um dieses Datenset zu importieren"
    },
    "readonly": "Schreibgeschützt"
  },
  "edit_photo_modal": {
    "title": "Photo editieren",
    "ok_button": "Speichern",
    "cancel_button": "Abbrechen"
  },
  "labels": {
    "description": "Beschreibung",
    "schema": "Schema"
  },
  "description_panel": {
    "control_icons": {
      "edit": "Bearbeiten",
      "save": "Speichern",
      "cancel": "Abbrechen",
      "submit": "Speichern",
      "delete": "Löschen",
      "manage": "Details"
    },
    "form": {
      "name": "Name",
      "description": "Beschreibung",
      "description_placeholder": "Beschreibung hinzufügen..."
    }
  },
  "support_form": {
    "title": "Support Ticket",
    "topic": "Thema",
    "subject": "Gegenstand",
    "message": "Nachricht",
    "confirmation_email": "Bestätigungs-E-Mail senden",
    "submit": "Absenden",
    "success_modal": "Vielen Dank für das Einreichen Ihres Support-Tickets. Unser Support-Team wird Ihren Fall prüfen und sich so schnell wie möglich mit einer Lösung oder Antwort an Sie zurückwenden."
  },
  "dataset_card": {
    "size_info": "{{finalSize}} ({{importSize}} import size)"
  },
  "jira_support": {
    "title": "Support Desk",
    "new_issue": "Ticket erstellen",
    "issues": "Tickets",
    "updatedAt": "Aktualisiert",
    "no_clusters": "Keine Clusters",
    "no_projects": "Keine Projekte",
    "no_organizations": "Keine Organisationen",
    "no_description": "Keine Beschreibung vorhanden",
    "no_comments": "Es gibt noch keine Kommentare",
    "notConfiguredUser": "Die Integration des Jira Service Desks ist derzeit nicht konfiguriert. Bitte wenden Sie sich an Ihren Administrator oder Super User.",
    "notConfiguredAdmin": "Die Integration des Jira Service Desks ist derzeit nicht konfiguriert (<b>Einstellungen</b> > <supportLink><b>Support</b></supportLink>).",
    "labels": {
      "description": "Beschreibung",
      "createdAt": "Erstellt am",
      "status": "Status",
      "cluster": "Cluster",
      "supportPlan": "Support Plan",
      "issueKey": "ID",
      "viewIssue": "Ticket öffnen",
      "createAnIssue": "Ticket erstellen",
      "chooseTicketType": "Wählen Sie den Tickettyp",
      "createIssue": "Ticket erstellen",
      "cancel": "Abbrechen",
      "organization": "Organisation",
      "organizations": "Organisationen",
      "projects": "Projekte",
      "summary": "Zusammenfassung",
      "submit": "Erstellen",
      "close": "Schließen",
      "issueDetails": "Details",
      "companyName": "Unternehmensname",
      "comments": "Kommentare",
      "send": "Senden",
      "project": "Projekt",
      "startAt": "Start bei",
      "show": "Öffnen"
    }
  },
  "services": {
    "title": "Services",
    "infoButtonTooltip": "Erfahren Sie mehr über dieses Produkt",
    "disabled": {
      "hint": "Dieses Produkt ist nicht aktiviert.",
      "cta": "Kontaktieren Sie unser Team um es freizuschalten!"
    },
    "types": {
      "babelfish": {
        "short": "Babelfish",
        "long": "Babelfish",
        "flavor": "Babelfish für PostgreSQL beschleunigt Ihre Reise von SQL Server Anwendungen zu PostgreSQL",
        "productLink": "https://babelfishpg.org/"
      },
      "cypex": {
        "short": "CYPEX",
        "long": "CYBERTEC Prototyping Express",
        "flavor": "Schnelle, skalierbare und anpassbare PostgreSQL-App-Entwicklung",
        "productLink": "https://www.cybertec-postgresql.com/en/products/cypex/"
      },
      "migrator": {
        "short": "Migrator",
        "long": "CYBERTEC Migrator",
        "flavor": "Der schnellste und kostengünstigste Weg, von Oracle zu PostgreSQL zu migrieren",
        "productLink": "https://www.cybertec-postgresql.com/en/products/cybertec-migrator/"
      },
      "pgee": {
        "short": "PGEE",
        "long": "CYBERTEC PostgreSQL Enterprise Edition",
        "flavor": "Sichere, hochleistungsfähige PostgreSQL mit transparenter Datenverschlüsselung und 24/7-Unterstützung auf Unternehmensebene",
        "productLink": "https://www.cybertec-postgresql.com/en/products/cybertec-postgresql-enterprise-edition/"
      },
      "postgres": {
        "short": "PostgreSQL",
        "long": "PostgreSQL",
        "flavor": "Die weltweit beliebteste Datenbank, die von fast 50 % der Entwickler wegen ihrer Erweiterbarkeit, Freiheit und Zuverlässigkeit bevorzugt wird",
        "productLink": "https://www.postgresql.org/"
      }
    }
  }
}
